"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_INOUT_TYPE = exports.UserInoutMessage = void 0;
var util_1 = require("../../util");
var limit_frequency_message_1 = require("./limit-frequency-message");
/**
 * 正常消息通过类型限频，人员进出消息存在数据交叉计算，自定义类型
 */
var USER_INOUT_TYPE = 'USER_INOUT_TYPE';
exports.USER_INOUT_TYPE = USER_INOUT_TYPE;
var UserInoutMessage = /** @class */ (function (_super) {
    __extends(UserInoutMessage, _super);
    function UserInoutMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userNewInfos = new Map();
        _this.userLeaves = new Map();
        return _this;
    }
    UserInoutMessage.prototype.shouldLimit = function (type) {
        return ["USER_NEWINFO" /* USER_NEWINFO */, "USER_LEAVE" /* USER_LEAVE */].includes(type);
    };
    UserInoutMessage.prototype.pushMessage = function (message) {
        var notice = message.body.notice;
        if (message.head.type === "USER_NEWINFO" /* USER_NEWINFO */) {
            this.pushUserNewInfo(notice);
        }
        if (message.head.type === "USER_LEAVE" /* USER_LEAVE */) {
            this.pushUserLeave(notice);
        }
    };
    UserInoutMessage.prototype.transfer = function () {
        var _a;
        if (!this.userNewInfos.size && !((_a = this.userLeaves) === null || _a === void 0 ? void 0 : _a.size)) {
            return;
        }
        util_1.ConnectionLog.info("transfer memberCount:" + this.memberCount + ", type:" + USER_INOUT_TYPE + ", duration:" + this.duration);
        this.transferUserNewInfo();
        this.transferUserLeave();
        // 清除已经分发给业务的消息缓存
        this.userNewInfos.clear();
        this.userLeaves.clear();
    };
    UserInoutMessage.prototype.transferUserNewInfo = function () {
        if (!this.userNewInfos.size) {
            return;
        }
        var userNewInNotices = Array.from(this.userNewInfos.values());
        this.userNewInfos.clear();
        var userNewInMessage = {
            head: {
                type: "USER_NEWINFOS" /* USER_NEWINFOS */,
            },
            body: {
                mem_count: this.memberCount,
                notices: userNewInNotices,
            },
        };
        this.transferToBusiness("USER_NEWINFOS" /* USER_NEWINFOS */, [userNewInMessage]);
    };
    UserInoutMessage.prototype.transferUserLeave = function () {
        var _a;
        if (!((_a = this.userLeaves) === null || _a === void 0 ? void 0 : _a.size)) {
            return;
        }
        var userLeaveNotices = Array.from(this.userLeaves.values());
        this.userLeaves.clear();
        var userLeavesMessage = {
            head: {
                type: "USER_LEAVES" /* USER_LEAVES */,
            },
            body: {
                mem_count: this.memberCount,
                notices: userLeaveNotices,
            },
        };
        this.transferToBusiness("USER_LEAVES" /* USER_LEAVES */, [userLeavesMessage]);
    };
    UserInoutMessage.prototype.pushUserNewInfo = function (notice) {
        if (!notice || !notice.uuId) {
            return;
        }
        if (this.userLeaves.has(notice.uuId)) {
            this.userLeaves.delete(notice.uuId);
        }
        else {
            this.userNewInfos.set(notice.uuId, notice);
        }
    };
    UserInoutMessage.prototype.pushUserLeave = function (notice) {
        if (!notice || !notice.uuId) {
            return;
        }
        if (this.userNewInfos.has(notice.uuId)) {
            this.userNewInfos.delete(notice.uuId);
        }
        else {
            this.userLeaves.set(notice.uuId, notice);
        }
    };
    return UserInoutMessage;
}(limit_frequency_message_1.LimitFrequencyMessage));
exports.UserInoutMessage = UserInoutMessage;
